import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrTicketStatus.ts
var t = () => e("ticketStatus");
//#endregion
export { t as useTrTicketStatus };
